/**
 * @generated SignedSource<<1e1f9130b48aaa4a25cd8827825eee60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMakeOfferButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedMakeOfferButton_user";
};
export type PdpSharedMakeOfferButton_user$key = {
  readonly " $data"?: PdpSharedMakeOfferButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMakeOfferButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMakeOfferButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "247104b797c433c1faa85768d6235e67";

export default node;
